import styled from 'styled-components';
import { WarningFill } from 'ui/icons';
import { colors, spacing, body2 } from 'ui/theme';

import { Placement, StyledLink } from 'modules/campaigns/lib/components/Placement';

const Wrapper = styled.div`
  position: relative;
  background: ${colors.grey1};
  border-radius: ${spacing.quarter};
  display: flex;
  flex-direction: column;
  gap: ${spacing.plusHalf};
  padding: ${spacing.base};

  ${StyledLink} {
    position: absolute;
    top: ${spacing.base};
    right: ${spacing.base};
  }
`;

const StyledWarningMessage = styled.span`
  ${body2}
  display: flex;
  align-items: center;
  gap: ${spacing.quarter};
`;

export const PlacementsSection = () => {
  return (
    <Wrapper data-test="placement-id">
      <Placement fieldName="placementId" />
      <StyledWarningMessage>
        <WarningFill color={colors.textSecondary} /> This cannot be changed once the campaign is
        created.
      </StyledWarningMessage>
    </Wrapper>
  );
};
